module.exports = __webpack_public_path__ + "media/images/app/toast/warning-9a154da58f00a65f79749ff5e7450205.svg";